export default "__VITE_ASSET__Kws$o9Jz__"